import { render, staticRenderFns } from "./CreateContractRevision.yaml?vue&type=template&id=74faa00c&component"
import script from "./CreateContractRevision.yaml?vue&type=script&lang=ts&component"
export * from "./CreateContractRevision.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports